import React, { useState, useEffect } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import API_ROUTES from "../../hooks/apiRoutes";

function NewPass(props) {
  const [senha, setSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Capturar os parâmetros da URL
  const email = searchParams.get('email');
  const passwordToken = searchParams.get('passwordToken');

  // Verificar se os parâmetros necessários estão presentes
  useEffect(() => {
    if (!email || !passwordToken) {
      setErro("Link inválido. Email ou token não encontrado.");
    }
  }, [email, passwordToken]);

  const handleCadastrar = async () => {
    if (!email || !passwordToken) {
      setErro("Link inválido. Email ou token não encontrado.");
      return;
    }

    if (!senha || !confirmacao) {
      setErro("Preencha todos os campos.");
      return;
    }

    if (senha !== confirmacao) {
      setErro("As senhas não coincidem.");
      return;
    }

    if (senha.length < 6) {
      setErro("A senha deve ter pelo menos 6 caracteres.");
      return;
    }

    setLoading(true);
    setErro("");

    try {
      const response = await fetch(API_ROUTES.SET_PASSWORD.default(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          passwordToken: passwordToken,
          password: senha
        })
      });

      if (response.ok) {
        alert("Senha alterada com sucesso!");
        navigate("/login");
      } else {
        const data = await response.json();
        setErro(data.message || "Erro ao alterar senha. Verifique se o link ainda é válido.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      setErro("Erro ao conectar com o servidor. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <img src="/imgs/reino_header_logo.svg" alt="Reinoplay Logo" className="login-logo" />
      <p style={{ color: "#fff", marginBottom: 10 }}>Cadastrar nova senha</p>
      <input
        type="password"
        placeholder="Senha"
        className="login-input"
        value={senha}
        onChange={(e) => setSenha(e.target.value)}
        disabled={loading}
      />
      <input
        type="password"
        placeholder="Repita a senha"
        className="login-input"
        value={confirmacao}
        onChange={(e) => setConfirmacao(e.target.value)}
        disabled={loading}
      />
      {erro && <p style={{ color: "red", marginTop: 10 }}>{erro}</p>}
      <button 
        className="login-button" 
        onClick={handleCadastrar}
        disabled={loading}
      >
        {loading ? "Alterando..." : "Alterar Senha"}
      </button>
    </div>
  );
}

export default NewPass;
